import { render, staticRenderFns } from "./SwitchAppItem.vue?vue&type=template&id=2d192456&"
import script from "./SwitchAppItem.vue?vue&type=script&lang=js&"
export * from "./SwitchAppItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports